import { HTTP } from '@/http-common'

function getDistrict (districtId) {
  return HTTP.get('/districts/' + districtId)
}

function addDistrict (districtData) {
  let data = JSON.stringify(districtData)

  return HTTP.post('/districts', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateDistrict (districtData) {
  let data = JSON.stringify(districtData)

  return HTTP.put('/districts/' + districtData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteDistrict (districtId) {
  return HTTP.delete('/districts/' + districtId)
}

function applyBilling (districtId, billDateTime) {
  return HTTP.get('/districts/' + districtId + '/apply-billing?bill_datetime=' + billDateTime)
}

export { getDistrict, addDistrict, updateDistrict, deleteDistrict, applyBilling }



// WEBPACK FOOTER //
// ./src/services/district.service.js